import Swiper from "swiper";
import "swiper/swiper-bundle.css";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";

// --- Fancybox dla wideo ---
const initVideoFancybox = () => {
  Fancybox.bind('[data-fancybox="video"]', {
    Thumbs: { autoStart: true },
    Toolbar: { display: ["zoom", "slideShow", "thumbs", "close"] },
  });
};
initVideoFancybox();

document.addEventListener("DOMContentLoaded", () => {
  const initThumbSlider = 0;
  const gallery = document.querySelector(".woocommerce-product-gallery");
  if (!gallery) return;

  const wrapper = gallery.querySelector(".woocommerce-product-gallery__wrapper");
  if (!wrapper) return;

  // Tworzymy kontenery Swiper
  const mainSlider = document.createElement("div");
  mainSlider.classList.add("swiper", "swiper-main");

  const thumbsContainer = document.createElement("div");
  thumbsContainer.classList.add(
    initThumbSlider ? "swiper" : "thumbs-container",
    initThumbSlider ? "swiper-thumbs" : "d-flex",
    ...(initThumbSlider ? [] : ["flex-wrap"])
  );

  const mainWrapper = document.createElement("div");
  mainWrapper.classList.add("swiper-wrapper");

  if (initThumbSlider) {
    const thumbWrapper = document.createElement("div");
    thumbWrapper.classList.add("swiper-wrapper");
    thumbsContainer.appendChild(thumbWrapper);
  }

  // Pobieramy obrazy
  const images = wrapper.querySelectorAll(".woocommerce-product-gallery__image img");

  images.forEach((img, index) => {
    // --- GŁÓWNY SLIDE ---
    const mainSlide = document.createElement("div");
    mainSlide.classList.add("swiper-slide");

    const anchor = img.closest("a");
    const largeSrc =
      anchor?.getAttribute("data-large_image") ||
      anchor?.getAttribute("href") ||
      img.getAttribute("data-large_image") ||
      img.src;

    const largeImg = document.createElement("img");
    largeImg.src = largeSrc;
    largeImg.alt = img.alt || "";

    // Tworzymy link Fancybox **tylko raz**
    const fancyboxLink = document.createElement("a");
    fancyboxLink.href = largeSrc;
    fancyboxLink.dataset.fancybox = "product-gallery";
    fancyboxLink.dataset.caption = img.alt || "";
    fancyboxLink.classList.add("fancybox-link");
    fancyboxLink.appendChild(largeImg);

    mainSlide.appendChild(fancyboxLink);
    mainWrapper.appendChild(mainSlide);

    // --- THUMB ---
    const thumbWrapperDiv = document.createElement("div");
    thumbWrapperDiv.classList.add("thumb");

    const thumbImg = img.cloneNode(true);
    thumbImg.dataset.index = index;
    thumbImg.removeAttribute("data-fancybox");
    thumbImg.removeAttribute("href");

    thumbWrapperDiv.appendChild(thumbImg);

    if (initThumbSlider) {
      const thumbSlide = document.createElement("div");
      thumbSlide.classList.add("swiper-slide");
      thumbSlide.appendChild(thumbWrapperDiv);
      thumbsContainer.querySelector(".swiper-wrapper").appendChild(thumbSlide);
    } else {
      thumbImg.style.objectFit = "cover";
      thumbImg.style.cursor = "pointer";
      thumbImg.style.transition = "0.2s";

      thumbImg.addEventListener("mouseenter", () => (thumbImg.style.opacity = "0.7"));
      thumbImg.addEventListener("mouseleave", () => (thumbImg.style.opacity = "1"));
      thumbImg.addEventListener("click", () => main.slideToLoop(index));

      thumbsContainer.appendChild(thumbWrapperDiv);
    }
  });

  mainSlider.appendChild(mainWrapper);

  // Wstawiamy slider i thumbsy do galerii
  gallery.innerHTML = "";
  gallery.appendChild(mainSlider);
  gallery.appendChild(thumbsContainer);

  // --- INICJACJA SWIPERA ---
  const main = new Swiper(".swiper-main", {
    spaceBetween: 10,
    loop: true,
  });

  if (initThumbSlider) {
    const thumbs = new Swiper(".swiper-thumbs", {
      spaceBetween: 10,
      slidesPerView: 5,
      freeMode: true,
      watchSlidesProgress: true,
    });
    main.thumbs.swiper = thumbs;
  }

  // --- Bindujemy Fancybox **raz** po utworzeniu slidera ---
  Fancybox.bind('[data-fancybox="product-gallery"]', {
    Thumbs: { autoStart: true },
    Toolbar: { display: ["zoom", "slideShow", "thumbs", "close"] },
  });

  // Przenosimy badge do galerii jeśli istnieje
  const badge = document.querySelector(".custom-badge-container");
  if (badge) gallery.appendChild(badge);
});